"use client"

import { useEffect, useState } from "react"
import { createClient } from "@/lib/supabase/client"
import type { User, Session } from "@supabase/supabase-js"

const supabase = createClient()

export function useAuth() {
  const [user, setUser] = useState<User | null>(null)
  const [session, setSession] = useState<Session | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const isStaging = process.env.NEXT_PUBLIC_VERCEL_ENV !== "production"

    const checkAuth = async () => {
      const {
        data: { session: currentSession },
      } = await supabase.auth.getSession()

      if (isStaging) {
        console.log("[Auth] Client state on mount:", {
          hasSession: !!currentSession,
          sessionUserId: currentSession?.user?.id || null,
          sessionExpiry: currentSession?.expires_at || null,
        })
      }

      setSession(currentSession)
      setUser(currentSession?.user ?? null)
      setLoading(false)
    }

    checkAuth()

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, newSession) => {
      if (isStaging) {
        console.log("[Auth] State change:", {
          event,
          hasSession: !!newSession,
          sessionUserId: newSession?.user?.id || null,
        })

        if (event === "SIGNED_IN") {
          console.log("[Auth] ✅ SIGNED_IN event detected - user authenticated successfully")
        }
      }

      setSession(newSession)
      setUser(newSession?.user ?? null)
      setLoading(false)
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [])
  // </CHANGE>

  return { user, session, loading }
}
